import { composite as o } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function t(r) {
  return o(r, [255, 255, 255, 0.16]);
}
function n(r) {
  return o(r, [0, 0, 0, 0.12]);
}
export {
  t as createHoverColor,
  n as createPressedColor
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/color/index.js
// module id = 1618
// module chunks = 67